import { ReactElement } from "react"
import styled from "@emotion/styled"
import { BulletPointData } from "../../types"
import { useTranslation } from "../../TranslationProvider"
import BulletPoint from "./BulletPoint"

function BulletPoints(): ReactElement {
  const { t } = useTranslation()
  const bulletPoints: BulletPointData[] = t("bulletPoints", {
    returnObjects: true,
  })

  return (
    <BulletPointsWrapper>
      {bulletPoints.map((bp, i) => {
        return <BulletPoint bp={bp} key={i} />
      })}
    </BulletPointsWrapper>
  )
}

const BulletPointsWrapper = styled.div`
  margin: 1rem 0;
  max-width: 90vw;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.7rem;
`

export default BulletPoints
